import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import KlarnaPaymentIcon from '../../../../../svg/component/paymentOptions/klarna_payment.svg';
import MessageType from '../../../../enums/MessageType';
import {stopOrderProcessing} from '../../../actions/site-actions';
import Translation from '../../../lang/Translation';
import KlarnaForm from '../../payment-methods/klarna/KlarnaForm';
import Message from '../../ui/Message/Message';
import CheckoutOverlay from '../CheckoutOverlay';

import './KlarnaOverlay.scss';

export function KlarnaOverlay(props) {
  const cancelPayment = () => {
    props.stopOrderProcessing(true);
  };
  
  const getKlarnaSDKAuthorizeErrors = () => {
    const {klarna, klarnaSDKFormat} = props;
    const klarnaDSKResult = klarna[klarnaSDKFormat];
    if (klarnaDSKResult?.auth?.error?.invalid_fields[0] === 'billing_address.email') {
      return <Message type={MessageType.ERROR}><Translation>klarna.email.not.accepted</Translation></Message>;
    }
    
    if (props.messageKey) {
      return <Message type={MessageType.ERROR}><Translation>{props.messageKey}</Translation></Message>;
    }
  };
  
  return (
    <CheckoutOverlay popup exitCallback={cancelPayment}>
      <div className="KlarnaOverlay">
        <div className="KlarnaOverlay__description">
          <img
            className="KlarnaOverlay__image"
            src={KlarnaPaymentIcon}
            alt=""
          />
          <p><Translation>payments.klarna.overlay.text.contents</Translation></p>
        </div>
        {getKlarnaSDKAuthorizeErrors()}
        <KlarnaForm />
      </div>
    </CheckoutOverlay>
  );
}

const mapStateToProps = (state) => {
  const paymentOption = state.payment.paymentOptionName.toLowerCase();
  const klarnaVarient = paymentOption.replace('klarna_', '');
  const klarnaSDKFormat = klarnaVarient === 'slice' ? 'pay_over_time' : `pay_${klarnaVarient}`;
  
  return {
    klarna: state.klarna,
    paymentOption,
    klarnaSDKFormat,
  };
};

KlarnaOverlay.propTypes = {
  klarna: PropTypes.object,
  klarnaSDKFormat: PropTypes.string,
  messageKey: PropTypes.string,
  stopOrderProcessing: PropTypes.func,
};

export default connect(
  mapStateToProps,
  {stopOrderProcessing},
)(KlarnaOverlay);
